module.exports = __webpack_public_path__ + "img/bgscreen3.403d2447.png";